import { QuestionCircleOutlined } from '@ant-design/icons';
export class IconStoreBase {
    constructor() {
        /** icon map */
        this.map = new Map([
            ['default', QuestionCircleOutlined],
            ['QuestionCircleOutlined', QuestionCircleOutlined],
        ]);
        this.map.set('default', QuestionCircleOutlined);
        this.map.set('QuestionCircleOutlined', QuestionCircleOutlined);
    }
    /** 获取全局的icon component */
    //@ts-ignore
    get(id) {
        const component = this.map.get(id);
        return component;
    }
    /** 设置全局的icon component */
    set(id, component) {
        this.map.set(id, component);
    }
    /** 判断是否有值 */
    has(id) {
        return this.map.has(id);
    }
}
export const IconStore = new IconStoreBase();
export default IconStore;
//# sourceMappingURL=index.js.map